import { Script } from 'gatsby';
import React, { type FC } from 'react';

import t from '@/i18n/current';

export const GtmDataLayerScript: FC = () => {
    return (
        <script
            dangerouslySetInnerHTML={{
                __html: `
                    window.dataLayer = window.dataLayer || [];
                    window.gtag = function() { dataLayer.push(arguments); };
                    gtag('consent', 'default', {
                        ad_storage: 'denied',
                        ad_user_data: 'denied',
                        ad_personalization: 'denied',
                        analytics_storage: 'denied',
                        functionality_storage: 'denied',
                        personalization_storage: 'denied',
                        security_storage: 'granted',
                        wait_for_update: 500
                    });
                    gtag('js', new Date());
                    gtag('config', '${t.seo.gtmId}');
                    window.dataLayer.push({'gtm.start': new Date().getTime(), event:'gtm.js'})
                `,
            }}
        />
    );
};

export const GtmScript: FC = () => {
    return <Script strategy="idle" src={`https://www.googletagmanager.com/gtm.js?id=${t.seo.gtmId}`} />;
};
